import type { DateFieldOption, ExportFormatType } from '../redux/types/data-options'

export const resolveExportFormatValue = (showDates: boolean, selectedDateOption: DateFieldOption): ExportFormatType => {
  if (showDates === true) {
    return selectedDateOption.exportFormat
  }
  return 'ICONS'
}
